import { Tooltip } from "primereact/tooltip";

export const DomaineState = ({ nifiStatus, domaineName }: { nifiStatus: string, domaineName:string }) => {
  return (
    <>
      <Tooltip target=".tooltip-nifi-synchronize-with-domaine" />
      <div>
        {nifiStatus.toLocaleLowerCase() !== "ok" && (
          <div>
            <i
              className="tooltip-nifi-synchronize-with-domaine pi pi-exclamation-circle"
              data-pr-tooltip={`le domaine ${domaineName} n'est pas synchronisé avec Nifi`}
              data-pr-position="right"
              style={{ color: "red", fontSize: "1rem", cursor: "pointer" }}
            ></i>
          </div>
        )}
      </div>
    </>
  );
};
